
<app-header [logoImg]="logoImg" stickyLogoImg="../../../assets/imgs/logo/se2in_logo_fullwhite.png" [stickyHeaderWhite]="true"></app-header>
<app-nav-tabs [currentApp]="currentApp"></app-nav-tabs>
<app-footer></app-footer>